<template>
	<div>
		<a :class="'vw-btn-'+module.title" v-html="module.icon" v-on:click="onBtnClick"></a>
		<div class="dashboard" v-show="showDashboard" ref="dashboard">
			<div  v-if="module.render" v-once ref="moduleDashboard" :is="module" @exec="exec" :uid="uid" :options="options"></div>
		</div>
	</div>
</template>

<script>

export default
{
    props: ["module", "options"],
    data()
    {
        return {
            showDashboard: false
        }
    },
    computed:
    {
        uid()
        {
            return this.$parent._uid
        }
    },
    methods:
    {
        closeDashboard()
        {
            this.showDashboard = false;
        },
        openDashboard()
        {
            this.showDashboard = true;
        },
        exec()
        {
            this.$parent.exec.apply(null, arguments)
        },
        onBtnClick($event)
        {
            var me = this;
            
            $event.preventDefault();

			if(this.module.action !== undefined)
			{
				this.exec.apply(null, this.module.action);
			}
            else if(this.module.render !== undefined)
            {
                me
                this.showDashboard = !this.showDashboard;
                return;
            }
        }
    }
}
</script>
